module.exports = __webpack_public_path__ + "img/7-Lactation.c6fa0f4d.png";